import { TableColumnMeta } from "ds/components/Table/types";

export const TEMPLATE_DEPLOYMENT_STACKS_COLUMNS_STORAGE_KEY = "deploymentStacksColumnsConfig";

export enum TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID {
  STATE = "STATE",
  NAME = "NAME",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const TEMPLATE_DEPLOYMENT_STACKS_COLUMN_CONFIG: Record<TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID, TableColumnMeta> =
  {
    [TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID.NAME]: {
      id: TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID.NAME,
      title: "Name",
      minWidth: 200,
      defaultWidth: 300,
      maxWidth: MAX_CELL_WIDTH,
      allowsSorting: false,
      resizable: true,
      canHide: false,
      canPin: true,
      canMove: true,
    },
    [TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID.STATE]: {
      id: TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID.STATE,
      title: "State",
      minWidth: 260,
      defaultWidth: 260,
      maxWidth: MAX_CELL_WIDTH,
      allowsSorting: false,
      resizable: true,
      canHide: false,
      canPin: true,
      canMove: true,
    },
    [TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID.DROPDOWN]: {
      id: TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID.DROPDOWN,
      title: "Stack actions",
      noHeader: true,
      minWidth: 60,
      defaultWidth: 60,
      maxWidth: 60,
      allowsSorting: false,
      resizable: false,
      canHide: false,
      configurable: false,
      canPin: false,
      canMove: false,
    },
  };
